let visitStarted = false;

/** True after any program page has mounted in this browser session. */
export function programVisitAlreadyStarted() {
  const started = visitStarted;
  visitStarted = true;
  return started;
}

function scanScrollKey(slug: string) {
  return `program-scan:${slug}`;
}

function scanSeenKey(slug: string) {
  return `program-scan-seen:${slug}`;
}

export function rememberProgramScan(slug: string) {
  try {
    sessionStorage.setItem(scanScrollKey(slug), String(window.scrollY));
    sessionStorage.setItem(scanSeenKey(slug), '1');
  } catch {
    // Back can still open the scan at the top.
  }
}

export function readProgramScan(slug: string): number {
  try {
    return Number(sessionStorage.getItem(scanScrollKey(slug)) || 0);
  } catch {
    return 0;
  }
}

export function markProgramScanUnseen(slug: string) {
  try {
    sessionStorage.setItem(scanSeenKey(slug), '0');
    sessionStorage.removeItem(scanScrollKey(slug));
  } catch {
    // A direct hub open still starts at the top of the place.
  }
}

export function markProgramScanSeen(slug: string) {
  try {
    sessionStorage.setItem(scanSeenKey(slug), '1');
  } catch {
    // Back can still open the scan at the top.
  }
}

export function programScanWasSeen(slug: string) {
  try {
    return sessionStorage.getItem(scanSeenKey(slug)) === '1';
  } catch {
    return false;
  }
}

export function programSlugFromPath(path: string) {
  const match = path.match(/^\/programs\/([^#?/]+)/);
  return match?.[1] ?? null;
}

export function returnsToProgram(state: unknown) {
  return Boolean(
    state && typeof state === 'object' && (state as { documentBack?: unknown }).documentBack === 'program'
  );
}

export function wantsProgramScanRestore(state: unknown) {
  return Boolean(
    state &&
      typeof state === 'object' &&
      (state as { restoreProgramScan?: unknown }).restoreProgramScan
  );
}

export function readFocusHubSlug(state: unknown): string | null {
  if (!state || typeof state !== 'object') return null;
  const value = (state as { focusHubSlug?: unknown }).focusHubSlug;
  return typeof value === 'string' && value.trim() ? value : null;
}

/** Program URL, including section hash and title filter, to reopen from a document. */
export function readHubReturn(state: unknown): string | null {
  if (!state || typeof state !== 'object') return null;
  const value = (state as { hubReturn?: unknown }).hubReturn;
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null;
  return value;
}
